import { styled, motion, colors } from '../../styles/base/_allBase.styles'

export const CustomButtonContainer = styled(motion.button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 100%;
  min-height: 4.8rem;
  padding: 1.25rem 2.2rem;
  border: 1px solid ${colors.warmPalette.primary};
  border-radius: .4rem;
  background: ${({ $secondary }) => $secondary ? colors.neutralPalette.white : colors.warmPalette.primary};
  /* Keep button labels above surrounding prose-link rules. */
  && {
    color: ${({ $secondary }) => $secondary ? colors.warmPalette.primary : colors.neutralPalette.white};
    text-decoration: none;
  }
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0;
  text-transform: none;
  cursor: pointer;
  box-shadow: 0 .8rem 2rem rgba(24,47,53,.14);
  transition: background .2s ease, border-color .2s ease, transform .2s ease, box-shadow .2s ease;
  &:hover { color:${colors.neutralPalette.white}; background:${colors.warmPalette.primaryDark}; border-color:${colors.warmPalette.primaryDark}; transform:translateY(-2px); box-shadow:0 1.2rem 2.8rem rgba(24,47,53,.2); }
  &:active { transform:translateY(0); }
  @media (max-width:479px){ width:100%; padding-inline:1.6rem; }
`

export const CustomButtonTree = styled(CustomButtonContainer)`width:min(100%, 48rem);`
